var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, hasMany } from '@ember-data/model';
import { alias } from '@ember/object/computed';
import { computed } from '@ember/object';
import { fragment } from 'ember-data-model-fragments/attributes';
import { inject as service } from '@ember/service';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export const SUBSCRIPTION_ITEMIZATION_API_VERSION = '2023-06-08';
let SubscriptionPlan = (_dec = attr('string', {
  defaultValue: CatalogObjectType.SUBSCRIPTION_PLAN,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = fragment('connect/subscription-plan/data', {
  defaultValue: {}
}), _dec3 = hasMany('connect/subscription-plan/plan-variation', {
  async: false
}), _dec4 = computed('subscriptionPlanData', 'subscriptionPlanVariations.lastObject.subscriptionPlanVariationData'), _dec5 = alias('subscriptionPlanData.name'), _dec6 = alias('legacyPlanData.checkoutLink'), _dec7 = alias('legacyPlanData.phases'), _dec8 = alias('subscriptionPlanData.canProrate'), _dec9 = alias('subscriptionPlanData.eligibleItemIds'), _dec10 = alias('subscriptionPlanData.eligibleCategoryIds'), _dec11 = alias('subscriptionPlanData.allItems'), _dec12 = alias('subscriptionPlanData.monthlyBillingAnchorDate'), _dec13 = alias('legacyPlanData.configuration'), _dec14 = hasMany('connect/item', {
  async: true
}), _class = (_class2 = class SubscriptionPlan extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "type", _descriptor2, this);
    _initializerDefineProperty(this, "subscriptionPlanData", _descriptor3, this);
    _initializerDefineProperty(this, "subscriptionPlanVariations", _descriptor4, this);
    _initializerDefineProperty(this, "name", _descriptor5, this);
    _initializerDefineProperty(this, "checkoutLink", _descriptor6, this);
    _initializerDefineProperty(this, "phases", _descriptor7, this);
    _initializerDefineProperty(this, "canProrate", _descriptor8, this);
    _initializerDefineProperty(this, "eligibleItemIds", _descriptor9, this);
    _initializerDefineProperty(this, "eligibleCategoryIds", _descriptor10, this);
    _initializerDefineProperty(this, "allItems", _descriptor11, this);
    _initializerDefineProperty(this, "monthlyBillingAnchorDate", _descriptor12, this);
    _initializerDefineProperty(this, "subscriptionConfiguration", _descriptor13, this);
    _initializerDefineProperty(this, "items", _descriptor14, this);
  }
  get legacyPlanData() {
    return this.features.isEnabled('buyersubs/updated_legacy_api_version') && this.subscriptionPlanVariations.lastObject ? this.subscriptionPlanVariations.lastObject.subscriptionPlanVariationData : this.subscriptionPlanData;
  }
  get isDeactivated() {
    if (this.subscriptionPlanVariations.length === 1) {
      return !this.presentAtAllLocations || !this.subscriptionPlanVariations?.firstObject?.presentAtAllLocations;
    }
    return !this.presentAtAllLocations;
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/subscription-plan'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptionPlanData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptionPlanVariations", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "legacyPlanData", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "legacyPlanData"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "checkoutLink", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "phases", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "canProrate", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "eligibleItemIds", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "eligibleCategoryIds", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "allItems", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "monthlyBillingAnchorDate", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "subscriptionConfiguration", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "items", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SubscriptionPlan as default };